import React from 'react';
import PropTypes from 'prop-types';
import SlotsListHeader from './SlotsListHeader';

export default class SlotsSection extends React.Component {
  render() {
    return (
      <div>
        <SlotsListHeader time={this.props.time} availableSlots={this.props.availableSlots} />
        {this.props.children}
      </div>
    );
  }
}

SlotsSection.propTypes = {
  children: PropTypes.object.isRequired,
  time: PropTypes.string.isRequired,
  availableSlots: PropTypes.number.isRequired
};
